import type React from 'react';
import { useTranslation } from 'react-i18next/';
import { useDispatch, useSelector } from 'react-redux';
import { updateAuth } from '../../actions/user';
import PageWithNavigation from '../PageWithNavigationComponent/index';

const PageWithNav = ({ children }: any) => {
  const { t } = useTranslation();
  const { language, role, accessType } = useSelector(
    (state: any) => state.user
  );
  const dispatch = useDispatch();

  const sideBar = [
    {
      to: `/${language}`,
      exact: true,
      text: t('home.menuTitle'),
      icon: 'Chart',
    },
    {
      to: `/${language}/orders`,
      text: t('orders.sectionTitle'),
      icon: 'Cart',
    },
    {
      to: `/${language}/planned-purchase`,
      text: 'Planned Purchase',
      icon: 'Cart',
    },
    {
      to: `/${language}/neo-loan`,
      text: 'Neo Loan',
      icon: 'Cart',
    },
    {
      to: `/${language}/pay-now`,
      text: 'Pay now',
      icon: 'Cart',
    },
    {
      to: `/${language}/subscriptions`,
      text: 'Subscriptions',
      icon: 'Renewals',
    },
    {
      to: `/${language}/abandoned`,
      text: 'Abandoned',
      icon: 'Cart',
    },
    {
      to: `/${language}/dispatches`,
      text: t('dispatches.menuTitle'),
      icon: 'Dispatch',
    },
    {
      to: `/${language}/merchant-settlements`,
      iconClass: 'rotate',
      text: t('settlements.merchant.menuTitle'),
      icon: 'Sync',
    },
    {
      to: `/${language}/partner-settlements`,
      iconClass: 'rotate',
      text: t('settlements.partner.menuTitle'),
      icon: 'Sync',
    },
    {
      to: `/${language}/outstandings`,
      // iconClass: 'rotate',
      text: t('outstanding.menuTitle'),
      icon: 'Outstanding',
    },
    {
      to: `/${language}/refunds`,
      text: t('refunds.menuTitle'),
      icon: 'Sync',
    },
    {
      to: `/${language}/partners`,
      text: t('partners.menuTitle'),
      icon: 'PartnerSVG',
    },
    {
      to: `/${language}/merchants`,
      text: t('merchants.menuTitle'),
      icon: 'Store',
    },
    {
      to: `/${language}/customers`,
      text: t('customer.menuTitle'),
      icon: 'Smile',
    },
    {
      to: `/${language}/disputes`,
      text: t('disputes.menuTitle'),
      icon: 'Alert',
    },
    {
      to: `/${language}/settings`,
      exact: true,
      text: t('settings.sectionTitle'),
      icon: 'SettingsMenu',
    },
  ];

  const CUSTOMER_CARE_PAGES = [
    'orders',
    'subscriptions',
    'abandoned',
    'customers',
    'pay-now',
    'planned-purchase',
    'neo-loan',
  ];
  const CUSTOMER_NOT_READ_PAGES = ['settings'];
  const cashewReadUser = accessType === 'READ';
  const CUSTOMER_CARE_SIDE_BAR = sideBar.filter((item) =>
    CUSTOMER_CARE_PAGES.includes(item.to.split('/').slice(-1)[0])
  );
  const CUSTOMER_READ_SIDE_BAR = sideBar.filter(
    (item) => !CUSTOMER_NOT_READ_PAGES.includes(item.to.split('/').slice(-1)[0])
  );

  const realSidebar = cashewReadUser ? CUSTOMER_READ_SIDE_BAR : sideBar;
  return (
    <PageWithNavigation
      updateAuth={updateAuth}
      type="cashew"
      postLogoutAction={() => dispatch({ type: 'RESET' })}
      sidebar={role === 'CUSTOMER_CARE' ? CUSTOMER_CARE_SIDE_BAR : realSidebar}
    >
      {children}
    </PageWithNavigation>
  );
};

export default PageWithNav;
